import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { reducers, metaReducers } from './reducers';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../../environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { CommonStoreModule } from './common-store/common-store.module';
import { HomeStoreModule } from './home-store/home-store.module';
import { FaqStoreModule } from './faq-store/faq-store.module';
import { HelpStoreModule } from './help-store/help-store.module';
import { LinksStoreModule } from './links-store/links-store.module';
import { DatasetsStoreModule } from './datasets-store/datasets-store.module';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forRoot(reducers, { metaReducers }),
        EffectsModule.forRoot([]),
        !environment.production ? StoreDevtoolsModule.instrument() : [],
        CommonStoreModule,
        HomeStoreModule,
        FaqStoreModule,
        HelpStoreModule,
        LinksStoreModule,
        DatasetsStoreModule
    ],
})
export class AppStoreModule {}
